module.exports = __webpack_public_path__ + "assets/img/thumb-ImuPro-1-Video.c554fa41.jpg";